import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mhuepp5kwa: FaireBrandEntity = {
  token: "b_mhuepp5kwa",
  type: "brand",
  name: "Baby in Styles",
  avatarUrl:
    "https://cdn.faire.com/fastly/10ee5e310530faf129ba76399236534af1ca2ba0431bb02fec0a77b48bdcd940.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/eb9b48e62eedd49c034568ef406c599a59ac6343054807ed5daaad2e6b76529d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/10ee5e310530faf129ba76399236534af1ca2ba0431bb02fec0a77b48bdcd940.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eb9b48e62eedd49c034568ef406c599a59ac6343054807ed5daaad2e6b76529d.jpeg",
  location: "Purcellville, VA, USA",
  minimumOrderDollars: 75,
  rating: 4.8,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "Being a mother has inspired me into creating beautiful and practical baby clothing, each piece has been made with love and care, it's a story of combining my love for my children, my creativity and entrepreneurial spirit.\n\nMy main focus is to bring you the best quality products and customer service.\n\nBaby in Styles started in August 2020 by Owner Connie Digges, mom to 7 beautiful kids.\n\nI love Creating/choosing the perfect designs and bringing them to life in our beautiful gowns!!\n\nAs a parent and consumer, it is important for me to fulfill my customers/retailers needs with the reassurance that you get 100% high quality with 100% Satisfaction guarantee with every purchase you make.\n\nWe truly appreciate your business and we’re grateful for the trust you have placed in us.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:11.592Z",
    importedBy: "entity-db-cli",
  },
};
